import { render, staticRenderFns } from "./EventPreview.vue?vue&type=template&id=43649660&"
import script from "./EventPreview.vue?vue&type=script&lang=js&"
export * from "./EventPreview.vue?vue&type=script&lang=js&"
import style0 from "./EventPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VChip,VDivider})
